// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"Modal_mainDiv__106-Y","header":"Modal_header__3PtYx","footer":"Modal_footer__2JinJ","content":"Modal_content__1WzCp"};